/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  UpdateApplicationInput,
  useUpdateApplicationMutation,
} from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";

type Props = {
  onSuccess: () => void;
};
export function useUpdateApplication({ onSuccess }: Props) {
  const [updateApplicationMutation, { client, ...rest }] =
    useUpdateApplicationMutation({
      onError: (error) => {
        showError(error.message);
      },
      onCompleted: () => {
        onSuccess();
        showSuccess(generateActionSuccessText("Application")()("updated")());
      },
    });

  async function updateApplication(data: UpdateApplicationInput) {
    await updateApplicationMutation({
      variables: {
        input: {
          ...data,
        },
      },
    });
  }

  return [updateApplication, { client, ...rest }] as const;
}
